import React, { useRef } from 'react';
import Container  from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Breadcrumb  from 'react-bootstrap/Breadcrumb';
import CustomImage from './CustomImage';
import styles from '../styles/SocialResponsibility.module.scss';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Card from 'react-bootstrap/Card';
import { sliderSpeed } from '../utils/constants';
import VideoTestimonials from './PST/VideoTestimonials';

const SocialResponsibilityComponent:React.FC=(props:any)=>{
    const csrPageData = props.pageData;
    const sliderRef = useRef<Slider>(null);
    const settings = {
        dotsClass: styles.sliderDots,
        dots: true,
        infinite: true,
        speed: sliderSpeed.desktopSpeed,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      };
      const gallarySettings = {
        dotsClass: styles.sliderDots,
        dots: true,
        infinite: true,
        speed: sliderSpeed.desktopSpeed,
        slidesToShow: 5,
        slidesToScroll: 5,
        arrows: true,
        appendDots: (dots: any) => (
            <ul>
                <li className={`${styles.arrowDot} ${styles.leftArrowContainer}`}>
                    <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
                        <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
                    </div>
                </li>
                {dots}
                <li className={`${styles.arrowDot} ${styles.rightArrowContainer}`}>
                    <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                        <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
                    </div>
                </li>
            </ul>
        ),
        responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
              }
            }
          ]
      };
      

     const renderTrustArea = (trustAreaData: any) => {
        return (
          <>
               {/* mobile img */}
                <Col  lg={6} md={6} xs={12}  className='d-block d-sm-none'>
                    <div  className={styles.trustAreaImg}>
                        {
                            trustAreaData.image?.length && 
                            trustAreaData.image.map((img:any, index:number)=>{
                            return(
                                    <div className={styles.platformDivImg}  key={index}>
                                        <CustomImage
                                            src={img.url}
                                            alt={img.alternativeText}
                                            width={200}
                                            height={200}
                                        />
                                    </div>
                                  )
                            })
                    }
                    </div>
                </Col>
                <Col lg={6} md={6} xs={12}>
                    <div className={styles.EmpoweringYou}>
                        <div className={styles.empoweringYouContent}>
                            <h3 className='mb-4'>
                                {trustAreaData.title}
                            </h3>
                            <div dangerouslySetInnerHTML={{ __html: trustAreaData.description }}></div>
                            <ul className='pl-0'>
                            {
                            trustAreaData.points?.length > 0 &&
                            trustAreaData.points.map((areaPoints: string, index: number) => {
                                return(
                                    <div key={index}>
                                        <li  className="subHeadUlLi">{areaPoints}</li>
                                    </div>
                                )
                              } 
                            )
                            }
                            </ul> 
                        </div>
                    </div>
                </Col>
                <Col  lg={6} md={6} xs={12} className='d-none d-sm-block'>
                    <div  className={styles.trustAreaImg}>
                        {
                            trustAreaData.image?.length && 
                            trustAreaData.image.map((img:any, index:number)=>{
                            return(
                                    <div className={styles.platformDivImg}  key={index}>
                                        <CustomImage
                                            src={img.url}
                                            alt={img.alternativeText}
                                            width={200}
                                            height={200}
                                        />
                                    </div>
                                  )
                            })
                    }
                    </div>
                </Col>
             </>
        )
      }


    return(
        <>
        <div id='socialResponsibility'>
            <div  className={styles.socialResponsibility}>
                <Container>
                    <div className={styles.breadcrum}>
                        <Row className='text-center'>
                            <Col lg={7} md={10} xs={12} className={styles.centered}>
                                <Breadcrumb>
                                <Breadcrumb.Item style={{ opacity: 0.5 }} href='/'>
                                    Home
                                </Breadcrumb.Item>
                                <Breadcrumb.Item href=''> Corporate Social Responsibility </Breadcrumb.Item>
                                </Breadcrumb>
                                <div className={styles.abttopContent}>
                                  <h1>{csrPageData.title}</h1>
                                </div>
                            </Col>
                        </Row>
                        <Row className='justify-content-center'>
                             <Col xl={9} lg={9} md={12} sm={12} className={styles.parentMainColumns}>
                                <div id='parent-mainImg' className={styles.parentMain}>
                                    {csrPageData.bannerImages?.length > 0 &&
                                       csrPageData.bannerImages.map((data:any, index:number)=>{
                                        return(
                                             <div key={index} className={styles.imgdiv}>
                                                <div className={`${styles.childa} ${styles.childa1}`}>
                                                    <CustomImage 
                                                        src={data.image?.url}    
                                                        alt={data.image?.alternativeText}
                                                        width={data.image?.width}
                                                        height={data.image?.height}
                                                        object-fit = 'fill'
                                                    />
                                                </div>
                                             </div> 
                                        )
                                       })
                                    }
                               
                                </div>
                            </Col>
                        </Row>

                        <Row className='justify-content-center'>
                            <Col lg={9} md={9} sm={12}>
                                <div className='para mt-5'>
                                    <p>{csrPageData.description}</p>
                                </div>
                            </Col>
                        </Row>
                        
                    </div>
                </Container>
            </div>

            <div id="totalBenefits" className={styles.totalBenefits}>
                <Container>
                        <Row className='justify-content-center'>
                           <Col lg={9} md={11} sm={12}>
                            <div className={styles.parentDiv}>
                                   <div className={`${styles.childDiv} ${styles.child3}`} 
                                   style={{ background: `url(${csrPageData.benefitsSection?.titleBgImage?.url})  no-repeat center`,
                                            backgroundSize:'contain',
                                            borderRadius:'50%',
                                            }}>
                                        <div className={styles.overlay}></div>
                                        <div className={`${styles.content3} ${styles.contentCenter}`}>
                                           <h5>{csrPageData.benefitsSection?.title}</h5>
                                           <p>{csrPageData.benefitsSection?.subTitle}</p>
                                        </div>
                                    </div>
                                    <div className={styles.benfitsPonits}>
                                     {
                                        csrPageData.benefitsSection?.points?.length && 
                                        csrPageData.benefitsSection.points.map((data:any, index:number)=>{
                                            return(
                                                    <div  key={index} className={`${styles.childDiv} ${styles.child1}`}  
                                                        style={{ backgroundColor: data?.pointBgColor || '#FFDCD8' }}>
                                                        <div className={`${styles.content1} ${styles.content}`}>
                                                            <h5>{data.title}</h5>
                                                            <p>{data.subTitle}</p>
                                                        </div>
                                                  </div>
                                            )
                                        })
                                    }
                                    </div>
                                </div>
                           </Col>
                        </Row>
                </Container>
            </div>

            {/* CSR intiative undertaken in 2021-22*/}
            <div  id="csrIntiative" className={styles.csrIntiative} style={{ backgroundColor:`${csrPageData.csrInitiative?.sectionBgColor}`}}>
                <Container>
                    <Row className='text-center'>
                        <h2>{csrPageData.csrInitiative?.title}</h2>
                    </Row>
                    <Row>
                        <div className={styles.techTabs}>
                            <Tabs
                            defaultActiveKey='CurrentYear'
                            transition={false}
                            id='techCapabilityTabs'
                            className={styles.tabs}
                            >
                            <Tab eventKey='CurrentYear' title='Current Year'>
                                <div className={styles.courseFinder}>
                                {/* Current Year */}
                                <div className={styles.techCabMarBott}>
                                    {/* Desktop View */}
                                    <div className='d-none d-sm-block'>
                                            {
                                                csrPageData.csrInitiative?.currentYears?.length && 
                                                csrPageData.csrInitiative.currentYears.map((data:any, index:number)=>{
                                                    return(
                                                        <div key={index} className={styles.contentDiv}>
                                                            {index % 2 === 0
                                                              ?<>
                                                                 <Row>
                                                                    <Col xs={12} lg={6} md={6} sm={6}  className={styles.content}>
                                                                            <div className={styles.courseFinderContent}>
                                                                                <h3>{data.title}</h3>
                                                                                <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
                                                                                
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={12} lg={6} md={6} sm={6}>
                                                                            {data.image &&
                                                                                <div className={styles.platformDivImg}>
                                                                                    <CustomImage
                                                                                    src={data.image?.url}
                                                                                    alt={data.image?.alternativeText}
                                                                                    width={450}
                                                                                    height={360}
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                              </>
                                                              :
                                                              <Row>
                                                                <Col xs={12} lg={6} md={6} sm={6}>
                                                                    {data.image &&
                                                                        <div className={styles.platformDivImg}>
                                                                            <CustomImage
                                                                            src={data.image?.url}
                                                                            alt={data.image?.alternativeText}
                                                                            width={450}
                                                                            height={360}
                                                                            />
                                                                        </div>
                                                                    }
                                                                </Col>
                                                                <Col xs={12} lg={6} md={6} sm={6} className={styles.content}>
                                                                    <div className={styles.courseFinderContent}>
                                                                        <h3>{data.title}</h3>
                                                                        <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            }
                                                        </div>
                                                        
                                                    )
                                                })
                                            }
                                      </div>

                                    {/* Mobile View */}
                                    <div className='d-block d-sm-none'>
                                        <Slider {...settings}>
                                           {
                                                csrPageData.csrInitiative?.currentYears?.length && 
                                                csrPageData.csrInitiative.currentYears.map((data:any, index:number)=>{
                                                    return(
                                                        <div key={index}>
                                                             <div className={styles.platformDivImg}>
                                                                    <CustomImage
                                                                    src={data.image?.url}
                                                                    alt={data.image?.alternativeText}
                                                                    width={500}
                                                                    height={360}
                                                                    />
                                                            </div>
                                                            <div className={styles.content}>
                                                                <div className={styles.courseFinderContent}>
                                                                <h3>{data.title}</h3>
                                                                <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </Slider>
                                    </div>
                                 </div>
                                </div>
                            </Tab>

                            {/* Last Year */}
                            {csrPageData.csrInitiative.lastYear && csrPageData.csrInitiative.lastYear.length > 0 && (
                               <Tab eventKey='LastYear' title='Last Year'>
                                    <div className={styles.courseFinder}>
                                        <div className={styles.techCabMarBott}>
                                            {/* Desktop View */}
                                            <div className='d-none d-sm-block'>
                                                {
                                                    csrPageData.csrInitiative.lastYear.map((data:any, index:number)=>{
                                                    return(
                                                        <div key={index} className={styles.contentDiv}>
                                                            {index % 2 === 0
                                                                ? <>
                                                                <Row>
                                                                    <Col xs={12} lg={6} md={6} sm={6} className={styles.content}>
                                                                        <div className={styles.courseFinderContent}>
                                                                            <h3>{data.title}</h3>
                                                                            <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={12} lg={6} md={6} sm={6}>
                                                                        <div className={styles.platformDivImg}>
                                                                            <CustomImage
                                                                            src={data.image?.url}
                                                                            alt={data.image?.alternativeText}
                                                                            width={500}
                                                                            height={360}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                </>
                                                                : 
                                                                <Row>
                                                                    <Col xs={12} lg={6} md={6} sm={6}>
                                                                        <div className={styles.platformDivImg}>
                                                                            <CustomImage
                                                                            src={data.image?.url}
                                                                            alt={data.image?.alternativeText}
                                                                            width={500}
                                                                            height={360}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={12} lg={6} md={6} sm={6} className={styles.content}>
                                                                        <div className={styles.courseFinderContent}>
                                                                            <h3>{data.title}</h3>
                                                                            <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            }
                                                        </div>
                                                    )
                                                    })
                                                }
                                            </div>
                                            {/* Mobile View */}
                                            <div className='d-block d-sm-none'>
                                                <Slider {...settings}>
                                                    {
                                                        csrPageData.csrInitiative?.lastYear?.length &&
                                                        csrPageData.csrInitiative.lastYear.map((data:any, index:number)=>{
                                                            return(
                                                                <div key={index}>
                                                                    {data.image &&
                                                                        <div className={styles.platformDivImg}>
                                                                            <CustomImage
                                                                            src={data.image?.url}
                                                                            alt={data.image?.alternativeText}
                                                                            width={500}
                                                                            height={360}
                                                                            />
                                                                        </div>
                                                                    }
                                                                    <div className={styles.content}>
                                                                        <div className={styles.courseFinderContent}>
                                                                        <h2>{data?.title}</h2>
                                                                        <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                    
                                                </Slider>
                                            </div>
                                        </div>
                                    </div>
                               </Tab>

                            )}
                            
                            </Tabs>
                        </div>
                    </Row>
                </Container>
            </div>

            {/*KC’s CS trust areas*/}
            <div id="kcTrustAreas" className={styles.kcTrustAreas}>
                <div className={styles.areaContent}>
                    <Container>
                        <Row>
                            <h2>{csrPageData.trustArea?.title}</h2>
                        </Row>
                        {
                            csrPageData.trustArea?.details?.length &&
                            csrPageData.trustArea.details.map((trustAreaData:any, index:number)=>{
                               return(
                                  <div key={index} className={styles.trustAreaPadding}>
                                    <Row>
                                     {index % 2 === 0
                                        ? <>
                                        <Col  lg={6} md={6} sm={12} xs={12} >
                                            <div  className={styles.trustAreaImg}>
                                               {
                                                    trustAreaData.image?.length && 
                                                    trustAreaData.image.map((img:any, index:number)=>{
                                                    return(
                                                        <div className={styles.platformDivImg}  key={index}>
                                                                <CustomImage
                                                                    src={img.url}
                                                                    alt={img.alternativeText}
                                                                    width={200}
                                                                    height={200}
                                                                />
                                                        </div>
                                                        )
                                                    })
                                            }
                                            </div>
                                        </Col>
                                        <Col lg={6} md={6} sm={12} xs={12}>
                                            <div className={styles.empoweringYou}>
                                                <div className={styles.empoweringYouContent}>
                                                    <h3 className='mb-4'>
                                                     {trustAreaData.title}
                                                    </h3>
                                                    <div dangerouslySetInnerHTML={{ __html: trustAreaData.description }}></div>
                                                    <ul className='pl-0'>
                                                    {
                                                        trustAreaData.points?.length > 0 &&
                                                        trustAreaData.points.map((areaPoints: string, index: number) => {
                                                            return(
                                                                <div  key={index}>
                                                                    <li className="subHeadUlLi">{areaPoints}</li>
                                                                </div>
                                                            )
                                                        }
                                                      )
                                                    }
                                                    </ul> 
                                                </div>
                                            </div>
                                        </Col>
                                        </>
                                        : renderTrustArea(trustAreaData)
                                    }
                                    </Row>
                                  </div>
                               )
                            })
                        }
                        
                    </Container>
                </div>

            </div>

            {/* Some glimpses of our CSR Events */}
            <div  id="csrGlimpses" className={styles.csrGlimpses} style={{ backgroundColor:`${csrPageData.csrGlimpses?.sectionBgColor}`}}>
               <Container>
                    <Row className='justify-content-center text-center'>
                         <Col xl={9} lg={9} sm={10} xs={12}>
                           <h2>{csrPageData.csrGlimpses?.title}</h2>
                           <div dangerouslySetInnerHTML={{ __html: csrPageData.csrGlimpses?.description }}></div>
                        </Col>
                    </Row>
                    <Row>
                        <div className={styles.gallery}>
                            <Slider {...gallarySettings} ref={sliderRef} className={styles.images}>
                                {
                                    csrPageData.csrGlimpses?.imageGalleries?.length &&
                                    csrPageData.csrGlimpses?.imageGalleries.map((imagesData:any, index:number)=>{
                                            return(
                                                <div key={index} className={styles.sliderDiv}>
                                                    <div className={`${styles.galleryImages} ${index % 2 === 0 ? styles.even : ''}`}>
                                                        <CustomImage src={imagesData.images?.url}
                                                            alt={imagesData.images?.alternativeText}
                                                            width={300}
                                                            height={300}
                                                        />
                                                    </div>
                                                </div>
                                            )
                                    })
                                }
                            </Slider>
                        </div>

                    </Row>
               </Container>
            </div>

            {csrPageData.videoTestimonial && <VideoTestimonials {...csrPageData.videoTestimonial} />}

            <div className={styles.testimonials} style={{backgroundColor: `${csrPageData.ceoSection?.sectionBgColor}`}}>
                <Container>
                    <Row>
                        <Col xs={12} md={12}>
                        <Card id='testimonials' className={styles.testimonialbg}>
                            <Card.Body className={styles.cardBody}>
                            <Row className={styles.rowPaddingBot}>
                                <Col
                                sm={2}
                                md={3}
                                xs={12}
                                className={styles.imgFixedBottom}
                                >
                                <CustomImage
                                    src={csrPageData.ceoSection?.image?.url}
                                    width={186}
                                    height={186}
                                    alt={csrPageData.ceoSection?.image?.alternativeText}
                                />
                                </Col>
                                <Col sm={10} md={9} xs={12}>
                                <div className={styles.uptag}>
                                <div dangerouslySetInnerHTML={{ __html: csrPageData.ceoSection?.message}}></div>
                                    <div className={styles.smalltext}>
                                    - Pankaj Agrawal, Co-Founder & CEO
                                    </div>
                                </div>
                                </Col>
                            </Row>
                            </Card.Body>
                        </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
        </>
    )
}
export default SocialResponsibilityComponent;